/**
 * Канон loopback для dev/edge: только 127.0.0.1 и ::1.
 * Не используем имя localhost в прикладной логике — открывайте http://127.0.0.1
 */
export function isLoopbackHost(hostname) {
  const h = String(hostname || '')
    .replace(/^\[|\]$/g, '')
    .toLowerCase();
  return h === '127.0.0.1' || h === '::1';
}
